import {createTheme} from "@mui/material";

//********************************************************************************
//* THEME
//********************************************************************************

const themeOptions = {
	  palette: {
			 mode: "dark",
			 primary: {
					main: "#b71c1c",
					light: "#b71c1c",
					dark: "#b71c1c",
			 },
			 secondary: {
					main: "#f50057",
			 },
			 background: {
					default: "#000000",
					paper: "#000000",
			 },
			 text: {
					primary: "rgba(255,255,255,0.9)",
					secondary: "rgba(255,255,255,0.75)",
					disabled: "rgba(255,255,255,0.5)",
					hint: "#bdbdbd",
			 },
			 divider: "rgba(255,255,255,0.5)",
	  },
	  typography: {
			 fontSize: 12,
			 fontWeightLight: 700,
			 fontWeightRegular: 700,
			 fontWeightMedium: 800,
			 fontWeightBold: 900,
	  },
	  shape: {
			 borderRadius: 8,
	  },
};

const APXTheme = createTheme(themeOptions); /* CREATE THE THEME */

export default APXTheme;


//********************************************************************************
//* COLOURS
//********************************************************************************



export const red_900 = "#b71c1c";
export const white = "#FFFFFF";
export const black = "#000000";
export const productColour = "#ffaa00";
export const businessColour = "#27b0ff";
export const industryColour = "#00bf00";
export const milestoneColour = "#ff26a5";
export const expenseColour = "#ff7d26";
export const expense_green_600 = "#208028";
